export const idx_data_pitch_right_64 = [];

let order = 0;

idx_data_pitch_right_64.push({
  fraction: '---',
  decimal: 0,
  order_idx: -1,
});

for (let i = 0; i < 2; i++) {
  let pref = i > 0 ? '' + i + ' ' : '';

  idx_data_pitch_right_64.push({
    fraction: i === 0 ? '0' : pref.trim(),
    decimal: i,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '1/64',
    decimal: i + 1 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '1/32',
    decimal: i + 1 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '3/64',
    decimal: i + 3 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '1/16',
    decimal: i + 1 / 16,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '5/64',
    decimal: i + 5 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '3/32',
    decimal: i + 3 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '7/64',
    decimal: i + 7 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '1/8',
    decimal: i + 1 / 8,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '9/64',
    decimal: i + 9 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '5/32',
    decimal: i + 5 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '11/64',
    decimal: i + 11 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '3/16',
    decimal: i + 3 / 16,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '13/64',
    decimal: i + 13 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '7/32',
    decimal: i + 7 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '15/64',
    decimal: i + 15 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '1/4',
    decimal: i + 1 / 4,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '17/64',
    decimal: i + 1 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '9/32',
    decimal: i + 9 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '19/64',
    decimal: i + 19 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '5/16',
    decimal: i + 5 / 16,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '21/64',
    decimal: i + 21 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '11/32',
    decimal: i + 11 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '23/64',
    decimal: i + 23 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '3/8',
    decimal: i + 3 / 8,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '25/64',
    decimal: i + 25 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '13/32',
    decimal: i + 13 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '27/64',
    decimal: i + 27 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '7/16',
    decimal: i + 7 / 16,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '29/64',
    decimal: i + 29 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '15/32',
    decimal: i + 15 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '31/64',
    decimal: i + 31 / 64,
    order_idx: order,
  });
  order++;

  idx_data_pitch_right_64.push({
    fraction: pref + '1/2',
    decimal: i + 1 / 2,
    order_idx: order,
  });
  order++;

  if (i < 1) {
    idx_data_pitch_right_64.push({
      fraction: pref + '33/64',
      decimal: i + 33 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '17/32',
      decimal: i + 17 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '35/64',
      decimal: i + 35 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '9/16',
      decimal: i + 9 / 16,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '37/64',
      decimal: i + 37 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '19/32',
      decimal: i + 19 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '39/64',
      decimal: i + 39 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '5/8',
      decimal: i + 5 / 8,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '41/64',
      decimal: i + 41 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '21/32',
      decimal: i + 21 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '43/64',
      decimal: i + 43 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '11/16',
      decimal: i + 11 / 16,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '45/64',
      decimal: i + 45 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '23/32',
      decimal: i + 23 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '47/64',
      decimal: i + 47 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '3/4',
      decimal: i + 3 / 4,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '49/64',
      decimal: i + 49 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '25/32',
      decimal: i + 25 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '51/64',
      decimal: i + 51 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '13/16',
      decimal: i + 13 / 16,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '53/64',
      decimal: i + 53 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '27/32',
      decimal: i + 27 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '55/64',
      decimal: i + 55 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '7/8',
      decimal: i + 7 / 8,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '57/64',
      decimal: i + 1 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '29/32',
      decimal: i + 29 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '59/64',
      decimal: i + 59 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '15/16',
      decimal: i + 15 / 16,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '61/64',
      decimal: i + 61 / 64,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '31/32',
      decimal: i + 31 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_right_64.push({
      fraction: pref + '63/64',
      decimal: i + 63 / 64,
      order_idx: order,
    });
    order++;
  }
}

idx_data_pitch_right_64.push({
  fraction: 'L 1/64',
  decimal: -1 + 1 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 1/32',
  decimal: -1 + 1 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 3/64',
  decimal: -1 + 3 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 1/16',
  decimal: -1 * (1 / 16),
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 5/64',
  decimal: -1 + 5 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 3/32',
  decimal: -1 + 3 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 7/64',
  decimal: -1 + 7 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 1/8',
  decimal: -1 * (1 / 8),
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 9/64',
  decimal: -1 + 1 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 5/32',
  decimal: -1 + 5 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 11/64',
  decimal: -1 + 11 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 3/16',
  decimal: -1 * (3 / 16),
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 13/64',
  decimal: -1 + 13 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 7/32',
  decimal: -1 + 7 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 15/64',
  decimal: -1 + 15 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 1/4',
  decimal: -1 * (1 / 4),
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 17/64',
  decimal: -1 + 17 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 8/32',
  decimal: -1 + 8 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 19/64',
  decimal: -1 + 19 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 5/16',
  decimal: -1 * (5 / 16),
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 21/64',
  decimal: -1 + 21 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 11/32',
  decimal: -1 + 11 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 23/64',
  decimal: -1 + 23 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 3/8',
  decimal: -1 * (3 / 8),
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 25/64',
  decimal: -1 + 25 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 13/32',
  decimal: -1 + 13 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 27/64',
  decimal: -1 + 27 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 7/16',
  decimal: -1 * (7 / 16),
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 29/64',
  decimal: -1 + 29 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 15/32',
  decimal: -1 + 15 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 31/64',
  decimal: -1 + 31 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 1/2',
  decimal: -1 * (1 / 2),
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 33/64',
  decimal: -1 + 33 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 17/32',
  decimal: -1 + 17 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 35/64',
  decimal: -1 + 35 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 9/16',
  decimal: -1 * (9 / 16),
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 37/64',
  decimal: -1 + 37 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 19/32',
  decimal: -1 + 1 / 32,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 39/64',
  decimal: -1 + 39 / 64,
  order_idx: order,
});
order++;

idx_data_pitch_right_64.push({
  fraction: 'L 5/8',
  decimal: -1 * (5 / 8),
  order_idx: order,
});
